<template>
<!--    <div tabindex="0">-->
        <EspMediaGallery :mediaList="images" @videoActivate="$emit('videoActivate')" />
<!--    </div>-->
</template>

<script>
import EspMediaGallery from './EspMediaGallery.vue';

export default {
    props:{
        value:{
            type:Array
        },
        // shown alone when value is empty (a step with audio but no image)
        defaultValue:{
            type:String,
            default:null
        },
    },
    components: {
        EspMediaGallery
    },
    computed:{

        images(){
            if (this._.isArray(this.value) && this.value.length>0) {
                return this.value;
            }
            return this.defaultValue ? [this.defaultValue] : [];
        },
    },
    data: () => ({

    }),
    updated(){

    },
    watch: {
    },
    methods:{


    }
}
</script>

<style>

</style>
